/* recently-viewed.js — <recently-viewed>
   Tracks the current product handle (on PDP) and renders a strip of
   recently viewed products by fetching each handle's card HTML
   from /products/<handle>?view=card (theme provides templates/product.card.liquid).
*/
(function () {
  if (customElements.get('recently-viewed')) return;
  const KEY = 'lanuit-recently-viewed';
  const MAX_STORED = 12;

  function readList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  }
  function writeList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch {}
  }

  // Track on PDPs
  function trackCurrent() {
    const meta = document.querySelector('meta[property="product:handle"], meta[name="product:handle"]');
    let handle = meta && meta.getAttribute('content');
    if (!handle) {
      const m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) handle = m[1];
    }
    if (!handle) return;
    const list = readList().filter(h => h !== handle);
    list.unshift(handle);
    writeList(list);
  }
  trackCurrent();

  class RecentlyViewed extends HTMLElement {
    async connectedCallback() {
      const limit = parseInt(this.dataset.limit, 10) || 6;
      const currentId = this.dataset.currentId || '';
      const target = this.querySelector('[data-rv-target]');
      const handles = readList();
      // Filter out the current product (by handle path)
      const m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
      const currentHandle = m ? m[1] : null;
      const toShow = handles.filter(h => h !== currentHandle).slice(0, limit);
      if (toShow.length < 2 || !target) { this.hidden = true; return; }

      // Fetch each handle's card view in parallel.
      // PURGE handles that 404 — they're stale references to deleted products
      // (cleans up after catalog wipes/renames and silences the console).
      // A 200 is NOT proof the product is showable: staff with a preview
      // session get 200 for unpublished products too. templates/product.card.liquid
      // returns an EMPTY body in that case, so treat blank exactly like a 404 —
      // otherwise the strip renders empty cards for draft items.
      const fetches = await Promise.allSettled(toShow.map(async h => {
        const r = await fetch(`/products/${h}?view=card`);
        const body = r.ok ? await r.text() : '';
        return { handle: h, ok: r.ok && body.trim() !== '', html: body };
      }));
      const stale = [];
      const html = fetches.map(p => {
        if (p.status !== 'fulfilled') return '';
        if (!p.value.ok) { stale.push(p.value.handle); return ''; }
        return `<li class="related-products__item">${p.value.html}</li>`;
      }).join('');
      if (stale.length) {
        writeList(readList().filter(h => !stale.includes(h)));
      }
      if (!html) { this.hidden = true; return; }
      target.innerHTML = html;
      this.hidden = false;
    }
  }
  customElements.define('recently-viewed', RecentlyViewed);
})();
